module.exports = __webpack_public_path__ + "static/media/1.83c0685b.jpg";